import { useTexts } from '../../useTexts'

import { form } from '../../formState'

import { createValidateSubject } from '../../hooks/createValidateSubject'

export function Subject() {
  const texts = useTexts()
  const notificationWay = form.useFormField('notificationWay')
  const notificationWayValue = notificationWay.field.value

  form.useAddFieldValidation<'subjectCustom'>('subjectCustom', (field, _formApi) => {
    const validationSubject = createValidateSubject(
      texts,
      field.value,
      notificationWayValue === 'EMAIL',
    )
    return (
      validationSubject.subjectCustomRequiredError?.message ||
      validationSubject.subjectCustomMaxLengthError?.message
    )
  })

  return (
    <form.TextField
      label={texts.subjectCustomLabel(notificationWayValue === 'EMAIL')}
      validateOn="focus blur change"
      name="subjectCustom"
      testId="subjectCustom"
    />
  )
}
